import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import UserLoginFormContainer from '../userLoginForm';
import TenantLoginForm from './tenantForm';


@inject('translationsStore', 'authStore', 'authenticationProvidersStore') @observer
export default class TenantLoginFormContainer extends Component {

    state = {
        isNextStep: false
    };

    componentDidMount() {
        if (this.props.authStore.values.tenant)
            this.onNextStepClick();
    }

    componentWillUnmount() {
        this.props.authStore.reset();
    }

    onNextStepClick = async () => {    
        await this.props.authenticationProvidersStore.getAllAuthenticationProvidersOfTenant();
        this.setState({ isNextStep: true });
    };

    onPrevStepClick = () => {
        this.setState({ isNextStep: false });
        this.props.authStore.reset();
        window.localStorage.removeItem('authStoreTenant')
    };

    render() {
        const userLoginForm = this.state.isNextStep ?
                             <UserLoginFormContainer onPrevStepClick={ this.onPrevStepClick } returnUrl={ this.props.returnUrl } /> : 
                             null;

        return !this.state.isNextStep && !window.localStorage.getItem('authStoreTenant') ? 
                <TenantLoginForm onNextStepClick={ this.onNextStepClick } /> : 
                userLoginForm;

    }
}